// extracted by mini-css-extract-plugin
export default {"btnAction":"APIKeysSection_btnAction__PFjjD","title":"APIKeysSection_title__kI1L1"};